// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-4f543091] .el-date-editor .el-range-separator {\n  width: 24px !important;\n}\n.summary-search[data-v-4f543091] {\n  padding: 15px;\n  margin: 15px 0;\n  background-color: #FFFFFF;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);\n}\n.summary-search .summary-search-btn[data-v-4f543091] {\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
